<template>
  <el-table :data="data" height="500"
    :header-cell-style="{ backgroundColor: '#FAFBFB', 'border-top': '1px solid #F0F1F2' }">
    <!-- <el-table-column fixed prop="date" label="日期" width="150"></el-table-column> -->
    <el-table-column prop="name" label="项目名称" width="180"></el-table-column>
    <el-table-column prop="num" label="期望回收问卷份数" width="150"></el-table-column>
    <el-table-column prop="is_design" label="问卷设计" width="90">
      <template slot-scope="scope">
        <span>{{ scope.row.is_design == '1' ? '是' : '否' }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="is_survey_sample" label="调查样本" width="90">
      <template slot-scope="scope">
        <span>{{ scope.row.is_survey_sample == '1' ? '是' : '否' }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="status" label="状态" width="100">
      <template slot-scope="scope">
        <span>{{ scope.row.status == '1' ? '已提交' : '待提交' }}</span>
      </template>
    </el-table-column>
    <el-table-column width="150" label="操作">
      <template scope="scope">
        <template v-if="scope.row.status == '0'">
          <el-button type="text" icon="el-icon-edit" @click="handleEmit(scope.row.id, 'edit')">编辑</el-button>
          <el-button type="text" icon="el-icon-position" @click="handleEmit(scope.row.id, 'release')">发布</el-button>
        </template>
        <template v-if="scope.row.status == '1'">
          <el-button type="text" icon="el-icon-view" @click="handleEmit(scope.row.id, 'detail')">查看</el-button>
        </template>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
export default {
  name: 'LsTable',
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    handleEmit (id, type) {
      this.$emit('edit', { id, type })
    }
  }
}
</script>
<style lang="less">
.el-table {
  width: 100%;

  tr {
    th:first-child {
      border-left: 1px solid #F0F1F2;
    }

    th:last-child {
      border-right: 1px solid #F0F1F2;
    }
  }

  th {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;

    .cell {
      font-weight: bold;
    }
  }

  .el-table__row {
    td .cell {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;

      .el-button--text {
        color: #FCAE07;
        font-size: 16px;
      }
    }

    .el-table__cell:first-child {
      border-left: 1px solid #F0F1F2;
    }

    .el-table__cell:last-child {
      border-right: 1px solid #F0F1F2;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/LsTable.vue